import type { DashboardLayoutZone } from "../types/dashboard";

export type DashboardLayoutPresetId = "blank" | "executive" | "classic" | "wide";

export interface DashboardLayoutPreset {
  id: DashboardLayoutPresetId;
  nameKey: string;
  descriptionKey: string;
  gridCols: number;
  rowHeight: number;
  zones: DashboardLayoutZone[];
}

/** Empty grid layouts — widget content is added by user/AI after creation. */
export const DASHBOARD_LAYOUT_PRESETS: DashboardLayoutPreset[] = [
  {
    id: "blank",
    nameKey: "dashboard.preset.blank.name",
    descriptionKey: "dashboard.preset.blank.description",
    gridCols: 12,
    rowHeight: 80,
    zones: [],
  },
  {
    id: "executive",
    nameKey: "dashboard.preset.executive.name",
    descriptionKey: "dashboard.preset.executive.description",
    gridCols: 12,
    rowHeight: 80,
    zones: [
      { x: 0, y: 0, w: 4, h: 3, labelKey: "dashboard.preset.zone.kpi" },
      { x: 4, y: 0, w: 4, h: 3, labelKey: "dashboard.preset.zone.kpi" },
      { x: 8, y: 0, w: 4, h: 3, labelKey: "dashboard.preset.zone.kpi" },
      { x: 0, y: 3, w: 6, h: 5, labelKey: "dashboard.preset.zone.chart" },
      { x: 6, y: 3, w: 6, h: 5, labelKey: "dashboard.preset.zone.chart" },
      { x: 0, y: 8, w: 12, h: 4, labelKey: "dashboard.preset.zone.table" },
    ],
  },
  {
    id: "classic",
    nameKey: "dashboard.preset.classic.name",
    descriptionKey: "dashboard.preset.classic.description",
    gridCols: 12,
    rowHeight: 80,
    zones: [
      { x: 0, y: 0, w: 8, h: 6, labelKey: "dashboard.preset.zone.chart" },
      { x: 8, y: 0, w: 4, h: 6, labelKey: "dashboard.preset.zone.kpi" },
      { x: 0, y: 6, w: 12, h: 4, labelKey: "dashboard.preset.zone.table" },
    ],
  },
  {
    id: "wide",
    nameKey: "dashboard.preset.wide.name",
    descriptionKey: "dashboard.preset.wide.description",
    gridCols: 12,
    rowHeight: 72,
    zones: [
      { x: 0, y: 0, w: 12, h: 4, labelKey: "dashboard.preset.zone.chart" },
      { x: 0, y: 4, w: 12, h: 4, labelKey: "dashboard.preset.zone.chart" },
      { x: 0, y: 8, w: 12, h: 3, labelKey: "dashboard.preset.zone.table" },
    ],
  },
];

export function getLayoutPreset(id: DashboardLayoutPresetId): DashboardLayoutPreset {
  return DASHBOARD_LAYOUT_PRESETS.find((p) => p.id === id) ?? DASHBOARD_LAYOUT_PRESETS[0];
}
